import * as Sentry from "@sentry/nuxt";

const { SENTRY_ENVIRONMENT, ENVIRONMENT } = useRuntimeConfig().public;

Sentry.init({
  environment: SENTRY_ENVIRONMENT || ENVIRONMENT || "unknown",

  dsn: "https://89e788113ceb97e0a3adce27bf2ad555@o4507820634800128.ingest.de.sentry.io/4507820637487184",
  maxBreadcrumbs: 50,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  integrations: [
    Sentry.replayIntegration({
      mask: [
        "#id_password"
      ],
      maskAllText: false,
      blockAllMedia: false
    })
  ],

  debug: false
});
